export const SITE = {
  brand: "Fiber Draft",
  brandShort: "Fiber Draft",
  tagline: "NYCT MTA Electrical Engineering Contractors",
  phone: "",
  email: "dkandpal@fiberdraft.net",
  address: "2000 Vermella Way, Woodbridge, NJ 07095",
  hours: "Mon–Fri · 08:00 – 18:00 EST",
  registry: "WBE Certified · CCNA & CCNP (Routing & Switching)",
};

export const SERVICES = [
  {
    id: "autocad",
    code: "S-01",
    title: "Electrical AutoCAD Drafting",
    short: "Precision drafting aligned with NYCT design standards.",
    points: [
      "One-line, riser, conduit, and panel-schedule drawings",
      "NYCT C-Standards & MTA EE-Series compliant layers",
      "Coordination with structural, mechanical, and signal teams",
      "Revision-controlled DWG / PDF packages",
    ],
    image:
      "https://images.pexels.com/photos/3862379/pexels-photo-3862379.jpeg",
  },
  {
    id: "asbuilt",
    code: "S-02",
    title: "As-Built Drawing Creation",
    short: "Field-verified record drawings — exactly what was installed.",
    points: [
      "On-site verification of conduit, cable, and equipment routes",
      "Red-line mark-up reconciliation against contract drawings",
      "Closeout submittals accepted by NYCT QA",
      "Digital archive in DWG, PDF, and BIM-ready formats",
    ],
    image:
      "https://images.pexels.com/photos/4458210/pexels-photo-4458210.jpeg",
  },
  {
    id: "fatsat",
    code: "S-03",
    title: "Technical Documentation — FAT & SAT",
    short:
      "Factory and Site Acceptance Test procedures, results, and closeout.",
    points: [
      "FAT test procedures, traceability matrices & witness reports",
      "SAT commissioning scripts for substations, RTUs & SCADA",
      "Non-conformance tracking and resolution documentation",
      "Final acceptance binders compliant with MTA C&E protocols",
    ],
    image:
      "https://images.pexels.com/photos/14319099/pexels-photo-14319099.jpeg",
  },
];

export const PROJECTS = [
  {
    id: "p1",
    code: "PRJ-2024-118",
    title: "ISIM-B Mod I — 22-Station Rollout",
    discipline: "Integrated Station Information Management",
    scope: "Shop Drawings · As-Builts",
    summary:
      "Full shop-drawing package and field-verified as-built documentation for the ISIM-B Mod I deployment across 22 NYCT subway stations — covering PA/CIS head-ends, fiber backbone, and equipment-room layouts.",
    image:
      "https://images.pexels.com/photos/29731398/pexels-photo-29731398.jpeg",
    span: "lg:col-span-8",
    year: "2024",
    stats: [
      { k: "Stations", v: "22" },
      { k: "Deliverable", v: "Shop + As-Built" },
      { k: "Discipline", v: "ISIM-B Mod I" },
    ],
  },
  {
    id: "p2",
    code: "PRJ-2023-091",
    title: "CCTV System — 23rd St, 28th St & 188th St Stations",
    discipline: "CCTV / Surveillance",
    scope: "Drafting · As-Built · FAT",
    summary:
      "IP-CCTV camera placement drawings, head-end equipment layouts, and conduit/cable schedules for the CCTV system deployment at 23rd St, 28th St, and 188th St stations — including FAT documentation for NVR aggregation racks.",
    image:
      "https://images.pexels.com/photos/14319099/pexels-photo-14319099.jpeg",
    span: "lg:col-span-4",
    year: "2023",
    stats: [
      { k: "Stations", v: "23rd · 28th · 188th" },
      { k: "Deliverable", v: "Shop + As-Built" },
      { k: "Discipline", v: "IP CCTV" },
    ],
  },
  {
    id: "p3",
    code: "PRJ-2023-054",
    title: "ESS — Electronic Security Systems Upgrade",
    discipline: "Electronic Security Systems (ESS)",
    scope: "Shop Drawings · SAT",
    summary:
      "Engineering shop drawings and SAT commissioning scripts for Electronic Security Systems — access control, intrusion detection, and integrated CCTV interface across mezzanine and platform levels, compliant with NYCT C-Standards.",
    image:
      "https://images.pexels.com/photos/4458210/pexels-photo-4458210.jpeg",
    span: "lg:col-span-4",
    year: "2023",
    stats: [
      { k: "Systems", v: "ACS + IDS" },
      { k: "Deliverable", v: "Shop + SAT" },
      { k: "Discipline", v: "ESS" },
    ],
  },
  {
    id: "p4",
    code: "PRJ-2022-138",
    title: "Substation #41 — Traction Power Upgrade",
    discipline: "Traction Power",
    scope: "As-Built · FAT",
    summary:
      "Field-verified as-built package for a 600 VDC rectifier substation servicing the Lexington Avenue corridor, including factory acceptance witness reports for the rectifier transformers.",
    image:
      "https://images.unsplash.com/photo-1678803262992-d79d06dd5d96",
    span: "lg:col-span-8",
    year: "2022",
    stats: [
      { k: "Rating", v: "600 VDC" },
      { k: "Corridor", v: "Lexington Av" },
      { k: "Discipline", v: "Traction Power" },
    ],
  },
  {
    id: "p5",
    code: "PRJ-2022-042",
    title: "CBTC Network Diagrams — Signal Communications",
    discipline: "CBTC / Signal Communications",
    scope: "Network Diagrams · Shop Drawings",
    summary:
      "Layer-2 and Layer-3 network topology diagrams, VLAN/routing schemas, and equipment-room shop drawings for CBTC signal communications backbone — covering wayside routers, switches, and cross-corridor fiber links.",
    image:
      "https://images.pexels.com/photos/3862379/pexels-photo-3862379.jpeg",
    span: "lg:col-span-4",
    year: "2022",
    stats: [
      { k: "Layers", v: "L2 · L3" },
      { k: "Scope", v: "CBTC Comms" },
      { k: "Discipline", v: "Networking" },
    ],
  },
];

export const STATS = [
  { value: "15+", label: "Years on NYCT contracts" },
  { value: "120+", label: "Drawing packages delivered" },
  { value: "100%", label: "FAT / SAT pass rate" },
  { value: "0", label: "Open NCRs at closeout" },
];

export const PROJECT_TYPES = [
  "AutoCAD Drafting",
  "As-Built Drawings",
  "FAT/SAT Documentation",
  "Full-Scope Engineering",
  "Consultation",
  "Other",
];
